var UC = {
    version: '0.0.1',
    browser: {
        feature: [
            'addEventListener',
            'cssTransition',
            'cssTransform',
            'historyAPI',
            'placeholder',
            'localStorage',
            'querySelectorAll',
            'viewportUnit'
        ]
    },
    toasty: {
        500: {
            title: '啊哦，貌似出了点问题',
            msg: '服务器正在充电，请稍后重试',
            clickToClose: true,
            timeout: 1800,
            sound: true,
            shake: true,
            html: true,
            theme: "default"
        },
        203: {
            title: '用户认证失败',
            msg: '请检查您的用户名和密码',
            clickToClose: true,
            timeout: 1800,
            shake: true,
            sound: true,
            html: true,
            theme: "default"
        }
    },
    data: {
        getMaxPage: function (total, limit) {
            total = total == 0 ? 1 : total;
            return total % limit == 0 ? total / limit : Math.floor(total / limit) + 1;
        }
    },
    location: {
        base: location.origin,
        api: {
            wyc: (location.origin||location.protocol+"//"+location.host) + '/api/wyc',
            pub: (location.origin||location.host) + '/api/pub'
        }
    },
    reg: {
        PSW: /^[A-Za-z0-9._!@#]{6,16}$/,
        //最大额度
        MAX_NUMBER: 1000000,
        // 有两位小数的正实数
        ARITHMETIC_NUMBER: /^[0-9]+(.[0-9]{1,2})?$/,
        // 正整数验证
        NATURAL_NUMBER: /^[0-9]*[1-9][0-9]*$/,
        // 正数&最大允许小数点后两位
        REBATE_NUMBER: /^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/,
        // 正数&最大允许小数点后三位
        PRICE_NUMBER: /^(0|[1-9][0-9]{0,9})(\.[0-9]{1,3})?$/,
        //手机号
        MOBILE_NUMBER: /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$|(^(1)\d{10}$)|^[400|800]\d{7,9}$/,
        //email
        EMAIL: /^\w+([\.-]?\w+)?@\w+([\.-]?\w+)?(\.\w{2,6})+$/,
        //url
        W_URL: /^(http|https|ftp)\:\/\/([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)?((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.[a-zA-Z]{2,4})(\:[0-9]+)?(\/[^/][a-zA-Z0-9\.\,\?\'\\/\+&amp;%\$#\=~_\-@]*)*$/g
    },
    api: [],
    constant: {
    	/**
         * 运营管理 安装工管理
         * 修改时间2018 1019 
         * 修改人:蒋重阳
         */
        add_operation_user: "api/wyc/api/add_operation_user", //添加运维人员
        get_operation_user: "api/wyc/api/get_operation_user", //查看运维人员
        update_operation_user: "api/wyc/api/update_operation_user", //更新运维人员
        
         add_erector_user: "api/wyc/api/add_erector_user", //添加运维人员
        get_erector_user: "api/wyc/api/get_erector_user", //查看运维人员
        update_erector_user: "api/wyc/api/update_erector_user", //更新运维人员
        
        start_user: "api/wyc/api/start_user",//启用用户
        disable_user: "api/wyc/api/disable_user",//禁用用户
        add_sub_user: "api/wyc/api/add_sub_user",// "添加子账户信息",
        get_sub_user: "api/wyc/api/get_sub_user",// "获取子账户信息",
        get_sub_user_list: "api/wyc/api/get_sub_user_list",// "获取子账户信息列表",
        update_sub_user: "api/wyc/api/update_sub_user",// "更新子账户信息",
        update_sub_user_password: "api/wyc/api/update_sub_user_password",// "更新子账户密码",
        delete_sub_user: "api/wyc/api/delete_sub_user",// "删除子账户",
        add_city_partner_user: "api/wyc/api/add_city_partner_user",// "添加城市合伙人信息",
        get_city_partner_user: "api/wyc/api/get_city_partner_user",// "获取城市合伙人信息",
        get_city_partner_user_list: "api/wyc/api/get_city_partner_user_list",// "获取城市合伙人信息列表",
        update_city_partner_user: "api/wyc/api/update_city_partner_user",// "更新城市合伙人信息",
        delete_city_partner_user: "api/wyc/api/delete_city_partner_user",// "删除城市合伙人",
        add_agent_user: "api/wyc/api/add_agent_user",// "添加代理商信息",
        get_agent_user: "api/wyc/api/get_agent_user",// "获取代理商信息",
        get_agent_user_list: "api/wyc/api/get_agent_user_list",// "获取代理商信息列表",
        update_agent_user: "api/wyc/api/update_agent_user",// "更新代理商信息",
        delete_agent_user: "api/wyc/api/delete_agent_user",// "删除代理商",
        add_commodity: "api/wyc/api/add_commodity",// "添加商品信息",
        get_commodity: "api/wyc/api/get_commodity",// "获取商品信息",
        get_commodity_list: "api/wyc/api/get_commodity_list",// "获取商品信息列表",
        update_commodity: "api/wyc/api/update_commodity",// "更新商品信息",
        delete_commodity: "api/wyc/api/delete_commodity",// "删除商品",
        add_device: "api/wyc/api/add_device",// "wyc登录设备信息",
        get_device_list: "api/wyc/api/get_device_list",// "获取设备列表",
        update_device: "api/wyc/api/update_device",// "更新设备信息",
        disable_device: "api/wyc/api/disable_device",// "禁止设备",
        get_device: "api/wyc/api/get_device",// "获去设备",
        validate_device_no: "api/wyc/api/validate_device_no",// "校验设备编号",
        start_device: "api/wyc/api/start_device",// "启用设备",
        download_device_template: "api/wyc/api/download_device_template",// "下载批量上传模板",
        create_device_by_excel: "api/wyc/api/create_device_by_excel",// "批量上传设备",
        generate_qr_code: "api/wyc/api/generate_qr_code",// "生成二维码",
        batch_set_device: "api/wyc/api/batch_set_device",// "批量设置",
        get_device_net_log_list: "api/wyc/api/get_device_net_log_list",// "获取上下线记录",
        download_device_info: "api/wyc/api/download_device_info",// "下载设备信息",
        delete_device: "api/wyc/api/delete_device",// "删除设备信息",
        get_order_list: "api/wyc/api/get_order_list",// "获取订单一览",
        get_order_info: "api/wyc/api/get_order_info",// "获取订单信息",
        download_order_info: "api/wyc/api/download_order_info",// "下载订单信息",
        order_refund: "api/wyc/api/order_refund",// "订单退费",
        order_finish: "api/wyc/api/order_finish",// "订单完成",
        withdraw_cash: "api/wyc/api/withdraw_cash",//申请提现
        accept_withdraw_cash: "api/wyc/api/accept_withdraw_cash",// "通过申请提现",
        reject_withdraw_cash: "api/wyc/api/reject_withdraw_cash",// "拒绝提现申请",
        /**
         * 账户余额提现通过、驳回
         * 修改时间2018 1019 
         * 修改人:蒋重阳
         */
        app_withdraw_cash_adopt:"api/wyc/api/app_withdraw_cash_adopt", //通过
        app_withdraw_cash_reject:"api/wyc/api/app_withdraw_cash_reject",//驳回
        get_withdraw_cash_list: "api/wyc/api/get_withdraw_cash_list",// "获取提现申请列表",
        paid_withdraw_cash: "api/wyc/api/paid_withdraw_cash",// "已打款",
        get_can_withdraw_cash_list: "api/wyc/api/get_can_withdraw_cash_list",// "获取我可以提现订单列表",
        get_withdraw_cash_info: "api/wyc/api/get_withdraw_cash_info",// "获取提现详情",
        add_advertisement: "api/wyc/api/add_advertisement",// "添加广告",
        update_advertisement: "api/wyc/api/update_advertisement",// "更新广告",
        delete_advertisement: "api/wyc/api/delete_advertisement",// "删除广告",
        get_advertisement: "api/wyc/api/get_advertisement",// "获取广告",
        get_advertisement_list: "api/wyc/api/get_advertisement_list",// "获取广告列表",
        update_advertisement_to_zero: "api/wyc/api/update_advertisement_to_zero",// "修改广告的点击次数",
        disable_or_enable_advertisement: "api/wyc/api/disable_or_enable_advertisement",// "禁用或者启用广告",
        get_app_user_list: "api/wyc/api/get_app_user_list",// "获取app用户列表",
        get_app_user: "api/wyc/api/get_app_user",// "获取app用户",
        delete_app_user: "api/wyc/api/delete_app_user",// "删除app用户",
        get_deposit_detail_list: "api/wyc/api/get_deposit_detail_list",// "获取app用户充值记录一览",
        get_app_user_deposit_detail: "api/wyc/api/get_app_user_deposit_detail",// "获取app用户充值记录",
        push_message_to_app_user: "api/wyc/api/push_message_to_app_user",// "消息推送给app用户",
        push_message_to_app: "api/wyc/api/push_message_to_app",// "消息推送给app用户",
        get_complained_list: "api/wyc/api/get_complained_list",// "获得申诉列表",
        get_complained: "api/wyc/api/get_complained",// "获得申诉详情",
        update_complained: "api/wyc/api/update_complained",// " 更新申诉信息",
        add_complained: "api/wyc/api/add_complained",// "添加申诉",
        add_information: "api/wyc/api/add_information",// "添加资讯信息",
        get_information: "api/wyc/api/get_information",// "获取资讯信息",
        update_information: "api/wyc/api/update_information",// "更新资讯信息",
        delete_information: "api/wyc/api/delete_information",// "删除资讯信息",
        get_information_list: "api/wyc/api/get_information_list",// "资讯信息列表",
        add_alipay_config: "api/wyc/api/add_alipay_config",// "添加支付宝配置",
        get_alipay_config: "api/wyc/api/get_alipay_config",// "获取支付宝配置信息",
        update_alipay_config: "api/wyc/api/update_alipay_config",// " 更新支付宝配置信息",
        add_wxpay_config: "api/wyc/api/add_wxpay_config",// "添加微信配置信息",
        get_wxpay_config: "api/wyc/api/get_wxpay_config",// "获取微信宝配置信息",
        update_wxpay_config: "api/wyc/api/update_wxpay_config",// "更新微信配置信息",
        add_foucs_wyc_wx_user: "api/wyc/api/add_foucs_wyc_wx_user",// "绑定微信零钱包",
        get_foucs_wyc_wx_user: "api/wyc/api/get_foucs_wyc_wx_user",// "获取微信零钱包用户数据",
        update_foucs_wyc_wx_user: "api/wyc/api/update_foucs_wyc_wx_user",// "更新微信零钱包用户数据",
        get_foucs_wx_user_qrcode: "api/wyc/api/get_foucs_wx_user_qrcode",// "获得绑定二维码",
        get_device_error_log_list: "api/wyc/api/get_device_error_log_list",// "获取设备故障信息列表",
        get_statistics_charge_station_list: "api/wyc/api/get_statistics_charge_station_list",// "统计商户、代理商、城市合伙人统计电量",
        set_system_config: "api/wyc/api/set_system_config",// "设定系统参数",
        get_action_log_list: "api/wyc/api/get_action_log_list",// "获取系统日志列表",
        get_system_config: "api/wyc/api/get_system_config",// "获取系统参数",
        update_system_config: "api/wyc/api/update_system_config",// "修改系统参数"
        get_business_user: "api/wyc/api/get_business_user",//获得商户信息
        update_business_user: "api/wyc/api/update_business_user",//更新商户信息
        device_unbundling: "api/wyc/api/device_unbundling",//解绑设备
        update_app_user: "api/wyc/api/update_app_user",//更新app用户信息
        add_business_user: "api/wyc/api/add_business_user",//添加商户
        device_binding: "api/wyc/api/device_binding",//解绑设备
        get_user: "api/wyc/api/get_user",//获取个人信息
        update_user_info: "api/wyc/api/update_user_info",//更新个人信息
        update_user_password: "api/wyc/api/update_user_password",//获取个人信息
        set_device_params: "api/wyc/api/set_device_params",
        get_device_statistics: "api/wyc/api/get_device_statistics",//获取桩状态
        force_finish_withdraw_cash: "api/wyc/api/force_finish_withdraw_cash",//强制完成
         /**
         * 社区管理
         * 修改时间2018 1116 
         * 修改人:蒋重阳
         */
        add_neighbourhood: "api/wyc/api/add_neighbourhood",//社区添加
        update_neighbourhood: "api/wyc/api/update_neighbourhood",//社区编辑
    },
    powerfun: function (params) {
        var apis = localStorage.getItem('powerapi');
        return apis.indexOf(params) >= 0;
    },
    powercontroll: {
        read: 'R',
        update: 'U',
        delete: 'D',
    },
    params: {
        "page_now": 1,
        "limit": 10000
    },
    GCJ02ToBD09: function (lat, lon) {
        var x = lon, y = lat;
        var x_pi = x_pi = 3.14159265358979324 * 3000.0 / 180.0;
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
        var tempLon = (z * Math.cos(theta) + 0.0065).toFixed(6);
        var tempLat = (z * Math.sin(theta) + 0.006).toFixed(6);
        var gps = {lat: tempLat, lon: tempLon};
        return gps;
    },
    BD09ToGCJ02: function (lat, lon) {
        var x = lon - 0.0065, y = lat - 0.006;
        var x_pi = x_pi = 3.14159265358979324 * 3000.0 / 180.0;
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
        var tempLon = (z * Math.cos(theta)).toFixed(6);
        var tempLat = (z * Math.sin(theta)).toFixed(6);
        var gps = {lat: tempLat, lon: tempLon};
        return gps;
    },
    radioChecked:function (obj) {
        var len = obj.length;

        for (var i = 0;i<len;i++){
            if (obj[i].checked){
                return obj[i].value;
            }
        }
        return '1'
    }
};

(function (feature) {
    // 浏览器特性侦测
    var usedFeature = UC.browser.feature;
    for (var i = 0; i < usedFeature.length; i++) {
        if (!feature[usedFeature[i]]) {
            window.onload = function () {
                document.body.outerHTML = '<span>' +
                    '您的浏览器过时了哟，请尽快' +
                    '<a href="http://browsehappy.com/" target="_blank">升级您的浏览器</a>' +
                    '<span>';
                throw new Error('您的浏览器过时了，请尽快升级！');
            };
        }
    }
})(feature);

// 生成csv并下载
function exportCsv(name, data, mapKeys) {
    // console.log(12312312)
    let tempBtn = document.getElementById("download-csv");
    if (tempBtn) {
        tempBtn.parentNode.removeChild(tempBtn);
    }
   
    // 防止最后一行丢失
    data.push(data[0])

    let headerData = [],
        keyData = [];

    Object.keys(mapKeys).forEach(key => {
        headerData.push(mapKeys[key])
        keyData.push(key)
    })
    //将数据转为csv需要的格式
    let csv = [
            headerData,
            ...data.map(item => {
                // console.log(item);
                var rowData = [];
                keyData.forEach(key => {
                  
                    rowData.push(item[key])
                })
                return rowData
            })
        ]
            .map(e => e.join(","))
            .join('\n');

    let sheet = {}; // 将要生成的sheet
	csv = csv.split('\n');
    csv.forEach(function(row, i) {
		row = row.split(',');
		if(i == 0) sheet['!ref'] = 'A1:'+String.fromCharCode(65+row.length-1)+(csv.length-1);
		row.forEach(function(col, j) {
			sheet[String.fromCharCode(65+j)+(i+1)] = {v: col};
		});
	});

    let workbook = {
		SheetNames: ['sheet1'],
		Sheets: {}
	};
	workbook.Sheets['sheet1'] = sheet;
	// 生成excel的配置项
	let wopts = {
		bookType: 'xlsx', // 要生成的文件类型
		bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
		type: 'binary'
	},
        wbout = XLSX.write(workbook, wopts);
    // 导出
    let link = document.createElement("a"),
        exportContent = '\uFEFF',
        blob = new Blob([s2ab(wbout)], {type:"application/octet-stream"});

    link.id = "download-csv"
    link.setAttribute("href", URL.createObjectURL(blob))
    link.setAttribute('download', name + ".xlsx")
    document.body.appendChild(link)
    link.click()
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
